@if (confirmationNumber$ | async) {
    <zci-remove-user-confirmation-page></zci-remove-user-confirmation-page>
}
@else {
    <zci-stepper class="stepper-top" [flow]="FlowKey.RAF"></zci-stepper>
}